import { HeadingStructureFailedReason } from '../../../types';
import { RuleId, RuleLevel } from '../../../types-v2';
import { getHTagNumber } from '../../../utils/get-h-tag-number';
import { parseAxeHeadingStructure } from './axe/parse-axe-heading-structure';
export const headingStructureRule = {
  axeParser: parseAxeHeadingStructure,
  checker: _ref => {
    let {
      htmlStrings
    } = _ref;
    let prevHeadingLevel;
    const failedHeadings = [];
    const failedReasons = [];
    htmlStrings.forEach(_ref2 => {
      let {
        id,
        htmlString
      } = _ref2;
      const currentHeadingLevel = getHTagNumber(htmlString);
      if (!prevHeadingLevel || !currentHeadingLevel) {
        prevHeadingLevel = currentHeadingLevel ?? prevHeadingLevel;
        return;
      }
      if (currentHeadingLevel - prevHeadingLevel > 1) {
        failedHeadings.push({
          id
        });
      }
      prevHeadingLevel = currentHeadingLevel;
    });
    const checkMainHeading = () => {
      const headings = htmlStrings.map(_ref3 => {
        let {
          id,
          htmlString
        } = _ref3;
        const level = getHTagNumber(htmlString);
        return {
          id,
          level,
          text: htmlString
        };
      });
      const mainHeadingCount = headings.filter(_ref4 => {
        let {
          level
        } = _ref4;
        return level === 1;
      }).length;
      return mainHeadingCount === 0 ? HeadingStructureFailedReason.NoMainHeading : mainHeadingCount > 1 ? HeadingStructureFailedReason.MultipleMainHeadings : undefined;
    };
    if (failedHeadings.length > 0) {
      failedReasons.push(HeadingStructureFailedReason.HeadingDefinition);
    }
    const mainHeadingResult = checkMainHeading();
    if (mainHeadingResult) {
      failedReasons.push(mainHeadingResult);
    }
    return {
      failedHeadings,
      failedReasons,
      status: failedReasons.length === 0 ? 'passed' : 'failed'
    };
  },
  level: RuleLevel.Page,
  ruleId: RuleId.HEADING_STRUCTURE
};
//# sourceMappingURL=heading-structure.js.map